 
import React, {useContext, useState} from "react";
import { confirmDialog } from 'primereact/confirmdialog';
import { useNavigate } from "react-router-dom"; 
import { useDispatch } from 'react-redux';
import { ErrorParse } from '../handlers/ErrorParse';
import { onChangeLoading } from "../../redux/actions/ActionApp";
import {LoginService} from '../services/LoginService';
import AppContext from '../../shared/components/AppContext';

import "./../../../styles/HeaderComponent.scss";
import {Dialog} from "primereact/dialog";
import ImportGroup from "./ImportGroup";
import { useTranslation } from 'react-i18next';

// Profile function
// Define profile actions
export default  function Profile() {

    const myContext = useContext(AppContext); 
    const navigate = useNavigate();
    const [importClient , SetImportGroup] = useState(false);
    const dispatch = useDispatch();
    const loginService = LoginService();
    const { t } = useTranslation();
    const accept = () => { 
        localStorage.removeItem('tokenMKT');
        navigate('/', { replace: true }); 
    };

    const reject = () => {};

    const confirm2 = () => {
        confirmDialog({
            message: t('PROFILE.DIALOG.MESSAGE_DELETE'),
            header: t('PROFILE.DIALOG.HEADER_DELETE'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept : () => {
                dispatch(onChangeLoading());
                loginService.DeleteAccount(myContext.user.SubjectId , myContext.user.role ).then(respon => {
                    accept();
                })
                .catch(error => {
                    myContext.notify6('alert' , 'Error' , ErrorParse(error) );
                })
                .finally(() => {
                    dispatch(onChangeLoading());
                })
            },
            reject
        });
    };

    const confirm = () => {
        confirmDialog({
            message: t('PROFILE.DIALOG.MESSAGE_LOGOUT'),
            header: t('PROFILE.DIALOG.HEADER_LOGOUT'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept,
            reject
        });
    };


    const navigateImport = () => {
        if (myContext.user.subscription_type === "Basic") {
            myContext.notify6('alert' , 'Error' , t('NOTIFICATIONS.NO_IMPORT_PLAN_BASIC') );
        } else {
            showImportGroup(true);
        }
    }
    const showImportGroup = (value) => {
        SetImportGroup(value);
    }

    return (
    <div className="Profile">
            <div>
                <label>{myContext.user.unique_name}</label>
                <ul>
                    <li>
                        <a href="#"  onClick={() =>  navigate('/ProfileInfo') }>{t('RESPONDENT.LIST.PROFILE')}</a>
                    </li>
                    {
                        myContext.user.role !== "Respondent" ?
                        <></>
                        :
                        <li>
                            <a  onClick={navigateImport} >{t('IMPORT_GROUP.BUTTON_IMPORT_PROFILE')}</a>
                        </li>
                    }
                    <li>
                        <a href="#" onClick={confirm} >{t('PROFILE.DIALOG.HEADER_LOGOUT')}</a>
                    </li>
                    <li>
                        <a href="#" onClick={confirm2} style={{color:'#FF6565'}}>{t('PROFILE.DELETE_ACCOUNT')}</a>
                    </li>
                </ul>
            </div>
        <Dialog visible={importClient} closable={false}  showHeader={false}>
            <ImportGroup  showImportGroup={showImportGroup} />
        </Dialog>
        </div>
    );
}
